import React from "react"
import { FaHome, FaUserPlus, FaCheck, FaListUl, FaRegSun, FaListOl, FaCogs, FaDatabase, FaArchive } from 'react-icons/fa'
// import { AiFillNotification, AiFillDatabase, AiOutlineOrderedList, AiOutlineUsergroupAdd } from 'react-icons/ai'
const user = JSON.parse(sessionStorage.getItem('user'))

const navigatorAdministrador = [
  {
    type: "groupHeader",
    groupTitle: "INDICADORES DE CERTIFICADOS"
  },
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    type: "groupHeader",
    groupTitle: "INDICADORES DE ALQUILER"
  },
  {
    id: "homeProductos",
    title: "Inicio Productos",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/homeProductos"
  },
  {
    id: "homeCotizaciones",
    title: "Inicio Cotizaciones",
    type: "item",
    icon: <FaDatabase size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/homeCotizaciones"
  },
  {
    id: "homeODS",
    title: "Inicio ODS",
    type: "item",
    icon: <FaArchive size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/homeODS"
  },
  {
    type: "groupHeader",
    groupTitle: "MÓDULO CONFIGURACIÓN"
  },
  {
    id: "sistem",
    title: "Sistema",
    type: "collapse",
    icon: <FaCogs size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "user",
        title: "Gestión usuario",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/user",
      }
    ]
  },
  {
    id: "config",
    title: "Configuración",
    type: "collapse",
    icon: <FaRegSun size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Parametros",
        title: "Parámetros",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/parametros",
      },
      {
        id: "sistema-instalacion",
        title: "Sist. de instalación",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/sistema-instalacion",
      },
      {
        id: "proveedores",
        title: "Proveedores",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/proveedores",
      },
    ]
  },
  {
    id: "clientes",
    title: "Clientes",
    type: "collapse",
    icon: <FaUserPlus size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadoclientes",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/clientes",
      }
    ]
  },
  {
    type: "groupHeader",
    groupTitle: "MÓDULO CERTIFICADOS"
  },
  {
    id: "Productos",
    title: "Productos",
    type: "collapse",
    icon: <FaListUl size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadoProductos",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "productos",
      },
      {
        id: "reporteProductos",
        title: "Reporte - Traza",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "reporte-productos",
      }
    ]
  },
  {
    type: "groupHeader",
    groupTitle: "MÓDULO ALQUILER"
  },
  {
    id: "Alquiler",
    title: "Alquiler",
    type: "collapse",
    icon: <FaListOl size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadoProductosAlquiler",
        title: "Productos",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "productos-para-alquiler",
      },
      {
        id: "listadoInventarioProductosAlquiler",
        title: "Inventario",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "inventario-producto",
      },
      {
        id: "listadoCotizacionDeServicio",
        title: "Cotización",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "cotizacion-de-servicio",
      },
      {
        id: "listadoOrdenDeServicio",
        title: "Orden de servicio",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "orden-de-servicio",
      },
    ]
  },
]

const navigatorGestor = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "config",
    title: "Configuración",
    type: "collapse",
    icon: <FaRegSun size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Parametros",
        title: "Parámetros",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/parametros",
      },
      {
        id: "sistema-instalacion",
        title: "Sist. de instalación",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/sistema-instalacion",
      },
    ]
  },
  {
    id: "clientes",
    title: "Clientes",
    type: "collapse",
    icon: <FaUserPlus size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadoclientes",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/clientes",
      }
    ]
  },
  {
    id: "Productos",
    title: "Productos",
    type: "collapse",
    icon: <FaListUl size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadoProductos",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "productos",
      },
      {
        id: "reporteProductos",
        title: "Reporte - Traza",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "reporte-productos",
      }
    ]
  },
  {
    id: "Alquiler",
    title: "Alquiler",
    type: "collapse",
    icon: <FaListOl size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadoProductosAlquiler",
        title: "Productos",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "productos-para-alquiler",
      },
      {
        id: "listadoInventarioProductosAlquiler",
        title: "Inventario",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "inventario-producto",
      },
      {
        id: "listadoCotizacionDeServicio",
        title: "Cotización",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "cotizacion-de-servicio",
      },
      {
        id: "listadoOrdenDeServicio",
        title: "Orden de servicio",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "orden-de-servicio",
      },
    ]
  },
]

const navigationConfig =
  user?.profile === 2 ? navigatorAdministrador :
  user?.profile === 3 ? navigatorAdministrador :
    []

export default navigationConfig
